import { takeAvatars } from '@components/ArtBoard/Threads'
import type { ID } from '@octopus-do/octopus-project-core'
import { CheckCircleSolid } from '@octopus-do/octopus-storybook/icons'
import type { Thread } from '@store/reducers/threads'
import type React from 'react'

import type { Comment, Recipient } from '@/types'
import { clsJoin } from '@/utils'
import { CommentatorsStack } from '../CommentatorsStack'
import css from './styles.module.css'

interface Props {
  active: boolean
  users: Record<ID, Recipient>
  thread: Thread
  comments: Comment[]
  onClick: () => void
}

export const ThreadBubble: React.FC<Props> = ({
  active,
  users,
  thread,
  comments,
  onClick,
}) => {
  const { owner, resolved } = thread
  const avatars = takeAvatars(owner, comments, users)

  const iconClass = clsJoin(
    css.resolved_icon,
    css.right_top,
    !resolved && css.open
  )

  const buttonClass = clsJoin(
    css.bubble_colors,
    css.thread_bubble,
    active && css.active
  )

  // todo: reuse ThreadAvatars component
  return (
    <button className={buttonClass} onClick={onClick}>
      <CommentatorsStack
        className={css.bubble}
        active={active}
        avatars={avatars}
        resolved={resolved}
      />
      <CheckCircleSolid className={iconClass} />
    </button>
  )
}
